import { useCallback, useEffect, useRef, useState } from 'react';

export default (reRender?: boolean) => {
  const [, setInitialRender] = useState(true);
  const initial = useRef(true);

  useEffect(() => {
    initial.current = false;
    if (reRender) {
      setInitialRender(false);
    }
  });

  return useCallback(() => initial.current, []);
};
